import { render, staticRenderFns } from "./OrmRequestInspection.vue?vue&type=template&id=57044455"
import script from "./OrmRequestInspection.vue?vue&type=script&lang=js"
export * from "./OrmRequestInspection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57044455')) {
      api.createRecord('57044455', component.options)
    } else {
      api.reload('57044455', component.options)
    }
    module.hot.accept("./OrmRequestInspection.vue?vue&type=template&id=57044455", function () {
      api.rerender('57044455', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/OrmRequestInspection.vue"
export default component.exports